/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CombineDocuments200ResponseData
 */
export interface CombineDocuments200ResponseData {
    /**
     * The ID of the retained lead
     */
    retained_lead_id: string;
    /**
     * Number of documents moved to the retained lead
     */
    documents_moved_count: number;
    /**
     * Number of leads cancelled
     */
    leads_cancelled_count: number;
}

/**
 * Check if a given object implements the CombineDocuments200ResponseData interface.
 */
export function instanceOfCombineDocuments200ResponseData(value: object): value is CombineDocuments200ResponseData {
    if (!('retained_lead_id' in value) || value['retained_lead_id'] === undefined) return false;
    if (!('documents_moved_count' in value) || value['documents_moved_count'] === undefined) return false;
    if (!('leads_cancelled_count' in value) || value['leads_cancelled_count'] === undefined) return false;
    return true;
}

export function CombineDocuments200ResponseDataFromJSON(json: any): CombineDocuments200ResponseData {
    return CombineDocuments200ResponseDataFromJSONTyped(json, false);
}

export function CombineDocuments200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombineDocuments200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'retained_lead_id': json['retained_lead_id'],
        'documents_moved_count': json['documents_moved_count'],
        'leads_cancelled_count': json['leads_cancelled_count'],
    };
}

export function CombineDocuments200ResponseDataToJSON(json: any): CombineDocuments200ResponseData {
    return CombineDocuments200ResponseDataToJSONTyped(json, false);
}

export function CombineDocuments200ResponseDataToJSONTyped(value?: CombineDocuments200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'retained_lead_id': value['retained_lead_id'],
        'documents_moved_count': value['documents_moved_count'],
        'leads_cancelled_count': value['leads_cancelled_count'],
    };
}

